import React from "react";
import { SurveyOuterCard } from "./SurveyCard";
import { InfoChip } from "../../../../designSystem/Chip";
import { Button } from "../../../../designSystem/button/Button";
import { ButtonRow } from "../../../../designSystem/button/ButtonRow";
import { H2 } from "../../../../designSystem/typography/Heading";
import { SurveyTxt } from "../../../../SurveyTxt";
import { Icon } from "../../../../designSystem/icons/Icons";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { colors } from "../../../../designSystem/colors/color";
import { SurveyFactBox } from "./SurveyFactBox";
import { SurveyStyledList } from "./SurveyStiledList";

type SurveyDoneViewProps = { txt: SurveyTxt, answerId:string, onChangeAnswer: () => void }
export function SurveyDoneView(props: SurveyDoneViewProps): JSX.Element {
    return (

        <SurveyOuterCard>

            <Flex justifyContent="flex-end">
                <InfoChip variant="filled-light">Indsendt i dag kl. {new Date().toLocaleTimeString()} - ref.: {props.answerId}</InfoChip>
            </Flex>

            <Flex flexDirection="column" gap={32} style={{maxWidth: '600px', margin: '0 auto'}}>

                <Flex justifyContent="center">
                    <Icon name="status_ok" size="large" color={colors.icon.success} />
                </Flex>

                <div>
                    <H2>{props.txt.overview_surveyCompleted_header}</H2>
                    <div dangerouslySetInnerHTML={{ __html: props.txt.overview_surveyCompleted_text }} />
                </div>

                <SurveyFactBox icon="domino_mask"
                    header2={props.txt.overview_surveyCompleted_anonymityHeader}
                    content={props.txt.overview_surveyCompleted_anonymityText}
                />

                <div>
                    <H2>{props.txt.overview_surveyCompleted_nextHeader}</H2>

                    <SurveyStyledList
                        items={[
                            {   header: props.txt.overview_surveyCompleted_collectionHeader,
                                text: props.txt.overview_surveyCompleted_collectionText,
                            },
                            {   header: props.txt.overview_surveyCompleted_analysisHeader,
                                text: props.txt.overview_surveyCompleted_analysisText,
                            },
                            {   header: props.txt.overview_surveyCompleted_actionPlansHeader,
                                text: props.txt.overview_surveyCompleted_actionPlansText,
                            }
                        ]}
                    />
                </div>

                <ButtonRow marginTop={20}>
                    <Button variant="filled" onClick={() => props.onChangeAnswer()} text={props.txt.overview_surveyCompleted_buttonChangeAnswer} />
                </ButtonRow>

            </Flex>
        
        </SurveyOuterCard>

    );
}